import { Progress } from "@/shared/interfaces";

const state: Progress = {
    isVisible: true,
    progress: {
        step1: {
            title: 'Algemene informatie',
            values: {
                isFilling: false,
                filled: false,
            }
        },
        step2: {
            title: 'Vragen & antwoorden',
            values: {
                isFilling: false,
                filled: false
            }
        },
        step3: {
            title: 'Samenvatting',
            values: {
                isFilling: false,
                filled: false
            }
        }
    },
    stepsActive: {
        step1: false,
        step2: false,
        step3: false
    }
};

const getters = {
    getProgressStatus(state: Progress, getters: any) {
      return state;
    },


    getIsStep1Filled(state: Progress) {
        return state.progress.step1.values.filled;
    },
    getIsStep2Filled(state: Progress) {
        return state.progress.step2.values.filled;
    },
    getIsStep3Filled(state: Progress) {
        return state.progress.step3.values.filled;
    },


    getIsStep1Active(state: Progress) {
        return state.stepsActive.step1;
    },
    getIsStep2Active(state: Progress) {
        return state.stepsActive.step2;
    },
    getIsStep3Active(state: Progress) {
        return state.stepsActive.step3;
    },
    

    getIsVisible(state: Progress, getters: any) {
      return state.isVisible;
    },
};

const mutations = {
    toggleProgress: (state: Progress, payload: any) => {
        switch(payload) {
            case 'start':
            case 'introduction':
                state.progress.step1.values = {isFilling: false, filled: false};
                state.progress.step2.values = {isFilling: false, filled: false};
                state.progress.step3.values = {isFilling: false, filled: false};
                state.progress = { ...state.progress }
                break;
            case 'generalInformation':
                state.progress.step1.values = {isFilling: true, filled: false};
                state.progress.step2.values = {isFilling: false, filled: false};
                state.progress.step3.values = {isFilling: false, filled: false};
                state.progress = { ...state.progress }
                break;
            case 'reportForm':
                state.progress.step1.values = {isFilling: false, filled: true};
                state.progress.step2.values = {isFilling: true, filled: false};
                state.progress.step3.values = {isFilling: false, filled: false};
                state.progress = { ...state.progress }
                break;
            case 'summary':
                state.progress.step1.values = {isFilling: false, filled: true};
                state.progress.step2.values = {isFilling: false, filled: true};
                state.progress.step3.values = {isFilling: true, filled: false};
                state.progress = { ...state.progress }
                break;
            default:
                state.progress = { ...state.progress }
        }
    },

    setStep1Unactive: (state: Progress) => state.stepsActive.step1 = false,
    setStep2Unactive: (state: Progress) => state.stepsActive.step2 = false,
    setStep3Unactive: (state: Progress) => state.stepsActive.step3 = false,

    setStep1Active: (state: Progress) => state.stepsActive.step1 = true,
    setStep2Active: (state: Progress) => state.stepsActive.step2 = true,
    setStep3Active: (state: Progress) => state.stepsActive.step3 = true,

    hide: (state: Progress) => state.isVisible = false,
    show: (state: Progress) => state.isVisible = true,
 };

const actions = {
    hide: ({ commit }: { commit: Function }) => commit("hide"),
    show: ({ commit }: { commit: Function }) => commit("show")
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};